var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebsiteTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "X_logo_2023_original 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.17165 7.12222L13.7542 1.91016H12.6687L8.68796 6.4348L5.51093 1.91016H1.8457L6.65104 8.75286L1.8457 14.2178H2.93124L7.13227 9.43865L10.4882 14.2178H14.1534M3.32304 2.71113H4.99073L12.6679 13.4562H10.9998",
    fill: "#4B4AD5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteTwitter);
export default __webpack_public_path__ + "static/media/website-twitter.95a25b6611b74b3524f7d19730241767.svg";
export { ForwardRef as ReactComponent };